export default class headerScrolled {
    constructor() {
        if (!this.setVars()) return;

        this.setEvents();
    }

    setVars() {
        this.scrollHeader = document.querySelector('body');
        if (!this.scrollHeader) return;

        this.lastScrollTop = 0;
        return true;
    }

    setEvents() {
        window.addEventListener('scroll', () => {
            const st = window.pageYOffset || document.documentElement.scrollTop;

            if (this.lastScrollTop > 100) {
                document.querySelector('body').classList.add(
                    'scrolled'
                );
            } else {
                console.log('remove');
                document.querySelector('body').classList.remove(
                    'scrolled'
                );
            }

            this.lastScrollTop = st <= 0 ? 0 : st;
        });
    }
}
